import React from 'react';
import { Image } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './AdminLogin.css';

interface LocationState {
  email: string;
}

const AdminForgotPasswordResult: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState | null;
  const email = state?.email || '';

  return (
    <div className="blank-container">
      <div className="blank-content">
        <div className="login-form-container">
          <div className='login-form-background'></div>
          <div className="text-center mb-4">
            <Image 
              src="/logo.svg" 
              alt="ESF Logo" 
              className="logo-image" 
            />
            <h4>メールを送信しました。</h4>
          </div>

          <div className="text-center mb-5">
            <p>
              パスワード再設定メールを<span>{email}</span> 宛に送りいたしました。<br />
              お送りしたメールの内容に従ってパスワードを再設定してください。
            </p>
          </div>

          <div className="login-button-container">
            <Link to="/admin" className='backlogin-link'>
              管理画面に戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPasswordResult;
